export function loadCategoryList(categories) {
    const list = document.querySelector('.categories__container .categories__list');
    list.innerHTML = '';

    if (categories.length <= 0) {
        list.insertAdjacentHTML(
            'beforeend',
            `
        <div class="noProcedures">No Categories Found</div>
        `
        );
    }

    if (categories.length > 0) {
        list.insertAdjacentHTML(
            'beforeend',
            `
        <div class="categories__list--title">Select a category</div>
        `
        );
    }

    if (categories.length > 0) {
        for (const category of categories) {
            const iconHtml = category.icon
                ? `<img src="${process.env.GOOGLE_CLOUD_ICON_URL}${category.icon}"/>`
                : '';

            list.insertAdjacentHTML(
                'beforeend',
                `
            <div class="category-item" data-category-id="${category.id}" data-category="${category.name}">
                ${iconHtml}
                <div class="category-item__info-wrapper">
                    <span class="category-item__name">${category.name}</span>
                </div>
                <span class="category-item__option" data-category-id="${category.id}">
                    <i class="category-item__icon-check ri-check-line"></i>
                </span>
            </div>
            `
            );
        }
    }
}

